import type { RootState } from "../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";

import { getParameter } from "../../store/app/general";
import { setSelectedReservation } from "../../store/orm/userSession";
import DatepickerInput from "../elements/datepicker/datepicker";
import StationPicker from "../elements/stationpicker/stationpicker";
import { useKeydownListener } from "../../hooks/useKeydownListener";
import ORMfunctions from "../../hooks/app/general";
import ormCalculations from "../../hooks/api/calculate";

function SearchModal(props: any) {
  const dispatch = useDispatch();

  const deliveryStation = useSelector((state: RootState) =>
    getParameter(state, "BINET_ALLOW_ONEWAY"),
  );
  const userSession = useSelector((state: RootState) => state.userSession);
  const containerRef = useRef<HTMLDivElement>(null);

  const [isLoading, setIsLoading] = useState(false);

  const options = useSelector(
    (state: RootState) => state.general.stationpickerOptions,
  );
  useEffect(() => {
    containerRef.current?.focus();
  });
  const mode = props.mode;

  const deepEntry = props.deepEntry ? props.deepEntry : false;

  const selectcar = () => {
    setIsLoading(true);

    switch (deepEntry) {
      case true:
        if (userSession.cargroup && userSession.cargroup !== "") {
          ormCalculations
            .calculate(userSession, true, userSession.cargroup)
            .then((res) => {
              dispatch(
                setSelectedReservation({ id: userSession.cargroup, data: res }),
              );
              window.location.href = "/reservation/step2";
            })
            .catch((err) => {
              console.error(
                `❌ Calculation failed for ${userSession.cargroup}:`,
                err,
              );
              window.location.href = "/reservation/step1";
              // dispatch(setPriceError(id));
            });
        } else {
          window.location.href = "/reservation/step1";
        }
        break;

      default:
        window.location.href = "/reservation/step1";
        break;
    }
  };

  // Keyboard navigation
  const handleKeydown = useCallback((event: KeyboardEvent) => {
    switch (event.key) {
      case "ArrowUp":
      case "ArrowDown":
      case "Enter":
        console.log(event.target!);

        break;
      case "Escape":
        event.preventDefault();
        props.close();
        break;
      case "Tab":
        break;
      default:
        break;
    }
  }, []);

  useKeydownListener(containerRef, handleKeydown);

  let button;
  if (isLoading) {
    button = <div className="loading"></div>;
  } else {
    button = (
      <button className="orm-btn orm-btn--large" onClick={selectcar}>
        {ORMfunctions.i18n("general/search")}
      </button>
    );
  }
  if (mode !== "inner")
    return (
      <div
        className="orm-html orm-modal orm-modal--stationtime orm-modal--overflowAuto"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        tabIndex={-1}
        ref={containerRef}
      >
        <div className="orm-container">
          <div className="orm-row center-xs middle-xs orm-h100vh">
            <div className="orm-col-xs-12 orm-col-sm-10 orm-col-md-6 orm-col-lg-4">
              <div
                className="orm-modal__inner orm-modal__inner--fullheight orm-pt-60 orm-pb-30 orm-px-8 orm-px-xs-30 orm-relative"
                tabIndex={-1}
                aria-modal="true"
                role="alertdialog"
                id="`modal-${$.uid}`"
              >
                <button
                  tabIndex={0}
                  className="orm-btn__small--black orm-btn__small--topright float-right"
                  aria-label="Schließen"
                  onClick={() => props.close()}
                >
                  <i className="fas fa-times"></i>
                </button>
                <div className="orm-row orm-mx-4">
                  <div className="orm-relative orm-col-xs-12">
                    <StationPicker
                      type="start"
                      useinputsearch={options.useinputsearch}
                      useapi={options.useapi}
                      regioncodes={options.regioncodes}
                      rangelimit={options.rangelimit}
                      resultlimit={options.resultlimit}
                      enabledstations={props.enabledstations}
                    />

                    {deliveryStation ? (
                      <StationPicker
                        type="end"
                        useinputsearch={options.useinputsearch}
                        useapi={options.useapi}
                        regioncodes={options.regioncodes}
                        rangelimit={options.rangelimit}
                        resultlimit={options.resultlimit}
                        enabledstations={props.enabledstations}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="orm-mb-16">
                  {" "}
                  <DatepickerInput type="modal" />
                </div>
                {button}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  else
    return (
      <div
        className="orm-html orm-modal orm-modal--inner"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        tabIndex={-1}
        ref={containerRef}
      >
        <div
          className="orm-modal__inner orm-modal__inner--fullheight orm-pt-60 orm-pb-30 orm-px-8 orm-px-xs-30 orm-relative"
          tabIndex={-1}
          aria-modal="true"
          role="alertdialog"
          id="`modal-${$.uid}`"
        >
          <button
            tabIndex={0}
            className="btn__small--black btn__small--topright float-right"
            aria-label="Schließen"
            onClick={() => props.close()}
          >
            <i className="fas fa-times"></i>
          </button>
          <div className="orm-relative orm-col-xs-12">
            <StationPicker
              type="start"
              useinputsearch={options.useinputsearch}
              useapi={options.useapi}
              regioncodes={options.regioncodes}
              rangelimit={options.rangelimit}
              resultlimit={options.resultlimit}
              enabledstations={props.enabledstations}
            />

            {deliveryStation ? (
              <StationPicker
                type="end"
                useinputsearch={options.useinputsearch}
                useapi={options.useapi}
                regioncodes={options.regioncodes}
                rangelimit={options.rangelimit}
                resultlimit={options.resultlimit}
                enabledstations={props.enabledstations}
              />
            ) : (
              <></>
            )}
          </div>
          <DatepickerInput type="modal" />

          {button}
        </div>
      </div>
    );
}

export default SearchModal;
